import PDLayout from '@/modules/pd/layout/PDLayout.vue';

const routes = [
  {
    path: 'dashboard',
    name: "pd-dashboard",
    component: () => import('@/modules/pd/views/Dashboard.vue')
  },
  {
    path: "reports",
    name: "pd-reports",
    component: () => import('@/modules/pd/views/Reports.vue')
  },
  {
    path: "reports/:reportId/report_type/:reportType",
    name: "pd-report-details",
    component: () => import('@/modules/pd/views/ReportDetails.vue')
  },
  {
    path: "uploads",
    name: "pd-uploads",
    component: () => import('@/modules/pd/views/UploadCenter.vue')
  },
  {
    path: "settings",
    name: "pd-settings",
    component: () => import('@/modules/pd/views/Settings.vue')
  },
];

export default {
  path: 'pd',
  name: 'pd',
  component: PDLayout,
  redirect : {
    name: 'pd-dashboard'
  },
  meta: {
    requiresAuth: false
  },
  children: [...routes]
};